var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "stars" },
    [
      _vm._l(_vm.flatNumber, function (index) {
        return _c("div", { key: index, staticClass: "sstar" }, [
          _c("img", { attrs: { src: _vm.normalIcon } }),
        ])
      }),
      _vm._v(" "),
      _vm.hasPlus
        ? _c("div", { staticClass: "sstarplus" }, [
            _c("img", { attrs: { src: _vm.plusIcon } }),
          ])
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }